import { useMutation } from "convex/react";
import { useNavigate } from "@tanstack/react-router";

import { api } from "@convex/_generated/api";
import { useAuth } from "@/hooks/useAuth";

export function useDeleteAccount() {
  const deleteAccountMutation = useMutation(api.users.deleteAccount);
  const { signOut } = useAuth();
  const navigate = useNavigate();

  async function deleteAccount() {
    await deleteAccountMutation();
    await signOut();
    navigate({ to: "/" });
  }

  return { deleteAccount };
}
